import { render, staticRenderFns } from "./CultureEvents.vue?vue&type=template&id=4e864182&scoped=true"
import script from "./CultureEvents.vue?vue&type=script&lang=js"
export * from "./CultureEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e864182",
  null
  
)

export default component.exports